module.exports = __webpack_public_path__ + "static/SharpSans-Bold-fdaec4e0601bd459f628b052c1a6b5b6.otf";